import "bootstrap/scss/bootstrap-grid.scss";
import 'swiper/swiper-bundle.css';
import 'aos/dist/aos.css';
import Swiper, { Navigation, Pagination } from 'swiper';
import AOS from 'aos/dist/aos.js';

//Swiper.use([Navigation, Pagination]);

document.addEventListener('DOMContentLoaded', () => {
  AOS.init({
    once: true,
    duration: 1200,
  });
});


(function ($, root, undefined) {
  $(function () {

    function formLabels() {
      $('.wpcf7 .form-input, .wpcf7 .form-textarea, .wpcf7 .form-select').focus(function () {
        $(this).parent().parent().addClass('active');
      }).blur(function () {
        var cval = $(this).val()
        if (cval.length < 1) {
          $(this).parent().parent().removeClass('active');
        } else {
          $(this).addClass('blur');
        }
      })
    }

    formLabels();

    var lastScrollTop = 0;

    $(window).scroll(function () {
      var st = $(this).scrollTop();

      if (st < 200 || st > lastScrollTop) {
        $(".header").removeClass("fixed");
      } else if (st == lastScrollTop) {
      } else if (st < lastScrollTop) {
        $(".header").addClass("fixed");
      }

      lastScrollTop = st;
    });

  });

})(jQuery, this);

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

// We listen to the resize event
window.addEventListener('resize', () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

const html = document.querySelector("html");

const header = document.querySelector('.header');
const headerHamburgerClose = document.querySelector('.header .hamburger--close');
const headerHamburgerOpen = document.querySelector('.header .hamburger--open');
const headerMenuPopup = document.querySelector('.header .nav__popup');

const headerMenuSubmenuParent = document.querySelectorAll('.header .nav__popup .menu-list .menu-item-has-children');
const headerMenuList = document.querySelector('.header .nav__popup .menu-list');

if (headerMenuPopup) {
  headerHamburgerClose.addEventListener('click', () => {
    headerMenuPopup.classList.add('active');
    html.classList.add('mobile-menu--open');
    headerHamburgerClose.setAttribute('aria-expanded', 'true');
    //header.classList.add('fixed');
  });

  headerHamburgerOpen.addEventListener('click', () => {
    headerMenuPopup.classList.remove('active');
    html.classList.remove('mobile-menu--open');
    headerHamburgerClose.setAttribute('aria-expanded', 'false');
    //header.classList.remove('fixed');
    headerMenuList.style = '';

    headerMenuSubmenuParent.forEach(el =>{
      el.classList.remove('active');
      let submenu = el.querySelector('.sub-menu');
      submenu.classList.remove('active');
    })
  });

  const headerMenuSubmenu = document.querySelectorAll('.header .nav__popup .sub-menu');

  headerMenuSubmenu.forEach(el =>{
    let li = document.createElement('li');
    li.classList.add('go-back');
    el.prepend(li);
  });

  

  headerMenuSubmenuParent.forEach(el =>{
    el.addEventListener('click',(e)=>{
      if(e.target != e.currentTarget) return;

      let submenu = el.querySelector('.sub-menu');

      el.classList.add('active');
      headerMenuList.style.height = submenu.scrollHeight + "px";
      submenu.classList.add('active');

      let submenuGoBack = submenu.querySelector('.go-back');

      submenuGoBack.addEventListener('click',()=> {
        submenu.classList.remove('active');
        headerMenuList.style = '';
        el.classList.remove('active');
      })
    })
  })

}


/* Language switcher - obsluga klawiatury + aria-expanded */

const langSwitchers = document.querySelectorAll('.nav__lang');

langSwitchers.forEach((lang) => {
  const trigger = lang.querySelector('[aria-haspopup]');
  if (!trigger) return;

  const setExpanded = (state) => trigger.setAttribute('aria-expanded', state ? 'true' : 'false');

  // Klawiatura: focus w obrebie przelacznika otwiera liste (wspolgra z :focus-within w CSS)
  lang.addEventListener('focusin', () => setExpanded(true));
  lang.addEventListener('focusout', (e) => {
    if (!lang.contains(e.relatedTarget)) setExpanded(false);
  });

  // Mysz: zachowanie spojne z :hover
  lang.addEventListener('mouseenter', () => setExpanded(true));
  lang.addEventListener('mouseleave', () => {
    if (!lang.contains(document.activeElement)) setExpanded(false);
  });

  // Enter/Spacja na wyzwalaczu przenosi focus do pierwszego jezyka; Escape zamyka
  trigger.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      setExpanded(true);
      const firstLink = lang.querySelector('.nav__lang-list a');
      if (firstLink) firstLink.focus();
    } else if (e.key === 'Escape') {
      setExpanded(false);
      trigger.blur();
    }
  });
});


/* Scrol top */

const scrollTop = document.querySelector('.footer__scroll-top');

if(scrollTop) {
  scrollTop.addEventListener('click', () => {
    window.scrollTo(0, 0);
  })
}

/* Cookie settings - otwarcie panelu zgod CookieYes z wlasnego przycisku (klika ukryty element wtyczki) */
document.querySelectorAll('.js-cookie-settings').forEach((btn) => {
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    const revisit = document.querySelector('[data-cky-tag="revisit-consent"]');
    if (revisit) revisit.click();
  });
});

/* Smooth  scroll */

const aTagWithHash = document.querySelectorAll('a[href^="#"]');

aTagWithHash.forEach(el => {
  let hash = el.getAttribute('href');
  //hash = hash.replace('#');
  let goto = document.querySelector(hash);

  el.addEventListener('click', (e)=>{
    e.preventDefault();
    goto.scrollIntoView({ behavior: 'smooth', block: "start", inline: "start" });
  });
})


/* Services - fixed menu */

const servicesMenu = document.querySelector('.services-page__menu');
const servicesMenuWrapper = document.querySelector('.services-page__menu-wrapper');
const servicesMenuListElems = document.querySelectorAll('.services-page__menu-list li');

if (servicesMenu) {
  let lastScrollTop = 0;

  window.addEventListener('scroll', () => {
    let st = window.pageYOffset;
    let top = window.pageYOffset + servicesMenuWrapper.getBoundingClientRect().top;
    let space = 200;

    if (st > top) {
      servicesMenu.classList.add('sticky');

      servicesMenuListElems.forEach((el) => {
        let dataID = el.dataset.id;
        const elem = document.querySelector('#' + dataID);

        let top = window.pageYOffset + elem.getBoundingClientRect().top;

        if (st > top - space) {
          el.classList.add('active');
        } else {
          el.classList.remove('active');
        }

        if (st > (top + elem.scrollHeight - space)) {
          el.classList.remove('active');
        }

      });
    } else {
      servicesMenu.classList.remove('sticky');
    }


    if (st < space || st > lastScrollTop) {
      servicesMenu.classList.remove('sticky--top');
    } else if (st == lastScrollTop) {
    } else if (st < lastScrollTop) {
      servicesMenu.classList.add('sticky--top');
    }

    lastScrollTop = st;
  });
}


/* Career - tabs */


const careerTabsList = document.querySelector('.career-page__third-tabs');
const careerTabs = document.querySelectorAll('.career-page__third-tabs li');
const careerTabBtns = document.querySelectorAll('.career-page__third-tabs li .tab-btn');
const careerTabsLast = document.querySelector('.career-page__third-tabs li:last-of-type');

const mediaTablet = window.matchMedia("(max-width: 991px)");



if(careerTabsList) {
  function careerTabsFunction() {
    let topList = window.pageYOffset + careerTabsList.getBoundingClientRect().top;
    let lastHeight = careerTabsLast.scrollHeight;
    let careerTabsListHeight = careerTabsList.scrollHeight;
    let listPb = parseFloat(window.getComputedStyle(careerTabsList, null).getPropertyValue('padding-bottom'));
    let listElemMb = parseFloat(window.getComputedStyle(careerTabsLast, null).getPropertyValue('margin-bottom'));
    let topLast = careerTabsListHeight - (lastHeight + listPb + listElemMb);
    let spacer = 77;

    const elems = careerTabs.length;
    let topFirst = topLast - (elems-1) * spacer;
    let i = 0;

    careerTabs.forEach((el)=> {
      el.dataset.top = topFirst + spacer*i;
      i++;
    });

    window.addEventListener('scroll', () => {
      let st = window.pageYOffset;
      let height = window.innerHeight;
      let topLast = window.pageYOffset + careerTabsLast.getBoundingClientRect().top;

      let heightPercent42 = height * (42/100);
      let spacerTop = spacer * elems + 20;

      if (topLast - st  < spacerTop) {
        careerTabs.forEach((el)=> {
          el.style.top = el.dataset.top + "px";
        });

        careerTabsList.style.height = careerTabsList.scrollHeight+"px";
        console.log('careerTabsList.scrollHeight '+careerTabsList.scrollHeight);
        careerTabsList.classList.add('absolute');

      } else {

        careerTabs.forEach((el)=> {
          el.style = "";
        });
  
        careerTabsList.style = "";
        careerTabsList.classList.remove('absolute');
      }
    });
  }

  function tabsBts(btn){
    let li = btn.currentTarget.parentNode;
    let description = li.querySelector('.tab-description');

    description.classList.toggle('active');
    btn.currentTarget.classList.toggle('active');

    if(description.classList.contains('active')){
      description.style.maxHeight = description.scrollHeight+"px";
    } else {
      description.style = "";
    }
  }

  careerTabBtns.forEach(el => {
    el.addEventListener('click', (e) =>{
      tabsBts(e);
    })
  })


  function mediaQueryCheck(e) {
    if (e.matches) { 
      careerTabsList.style = "";
      careerTabsList.classList.remove('absolute');
    } else {
      careerTabsFunction();
    }
  }

  mediaQueryCheck(mediaTablet);
  mediaTablet.addListener(mediaQueryCheck);
}

function getStyle(oElm, strCssRule){
  var strValue = "";
  if(document.defaultView && document.defaultView.getComputedStyle){
      strValue = document.defaultView.getComputedStyle(oElm, "").getPropertyValue(strCssRule);
  }
  else if(oElm.currentStyle){
      strCssRule = strCssRule.replace(/\-(\w)/g, function (strMatch, p1){
          return p1.toUpperCase();
      });
      strValue = oElm.currentStyle[strCssRule];
  }
  return strValue;
}


/* Form - files */

let uploadInput = document.getElementById("file-attachments");
let dropZone = document.querySelector(".form-file-btn");
let formFileList = document.querySelector(".form-file-list");

if (uploadInput) {
  let filesArray = [];

  uploadInput.setAttribute('accept', '.pdf,.doc,.docx');

  function FileListItems(files) {
    var b = new ClipboardEvent("").clipboardData || new DataTransfer()
    for (var i = 0, len = files.length; i < len; i++) b.items.add(files[i])
    return b.files
  }

  uploadInput.addEventListener('change', () => {
    let files = uploadInput.files;

    if (files.length) {
      updateFileList(files);
    }

    console.log(files);
    console.log("---");
    console.log(filesArray);
  });

  dropZone.addEventListener('dragover', e => {
    e.preventDefault();
    //dropZone.classList.add('add-place__drag-zone--over');
    //console.log('over');
  });

  ["dragleave", "dragend"].forEach(type => {
    dropZone.addEventListener(type, e => {
      //dropZone.classList.remove('add-place__drag-zone--over');
    });
  });

  dropZone.addEventListener('drop', e => {
    e.preventDefault();

    if (e.dataTransfer.files.length) {
      var files = e.dataTransfer.files;
      var file = e.dataTransfer.files[0];

      updateFileList(files);
      //files = new FileListItems(filesArray);
      files = new FileListItems(files);
      uploadInput.files = files;

      console.log('drop');

      console.log(uploadInput.files);
    }
  });
}

function updateFileList(files) {
  formFileList.innerHTML = '';

  for (var i = 0; i < files.length; i++) {
    //filesArray.push(files[i]);
    let li = document.createElement("li");
    let newContent = document.createTextNode(files[i].name);
    li.appendChild(newContent);
    formFileList.appendChild(li);
  }
}



/* Career page - form popup */

const popupFormOpenBtns = document.querySelectorAll('.single-job-offer__box-btn, .career-page__fourth-btn');

const popupFormCloseBtn = document.querySelector('.career-form-popup__close-btn');
const popupFormWrapper = document.querySelector('.career-form-popup__wrapper');
const popupThankyouWrapper = document.querySelector('.career-thankyou-popup__wrapper');
const popupThankyouCloseBtn = document.querySelector('.career-thankyou-popup__close-btn');
const popupThankyouCancelBtn = document.querySelector('.career-thankyou-popup__cancel-btn');

if(popupFormOpenBtns) {
  popupFormOpenBtns.forEach(el => {
    el.addEventListener('click', ()=> {
      popupFormWrapper.classList.add('active');
    })
  })
}

if(popupFormCloseBtn) {
  popupFormCloseBtn.addEventListener('click', ()=> {
    popupFormWrapper.classList.remove('active');
  })
}

if(popupThankyouCloseBtn) {
  popupThankyouCloseBtn.addEventListener('click', ()=> {
    popupThankyouWrapper.classList.remove('active');
  })
}

if(popupThankyouCancelBtn) {
  popupThankyouCancelBtn.addEventListener('click', ()=> {
    popupThankyouWrapper.classList.remove('active');
  })
}


//wpcf7mailsent
//wpcf7submit

document.addEventListener('wpcf7mailsent', function (event) {
  if(event.detail.contactFormId == '245' || event.detail.contactFormId == '243') {
    popupFormWrapper.classList.remove('active');
    popupThankyouWrapper.classList.add('active');
  }
}, false);



/* Contact page - form */

const formNewBtn = document.querySelector('.contact-page__contact-box-thankyou-new');
const formThankyouWrapper = document.querySelector('.contact-page__contact-box-thankyou');
const formWrapper = document.querySelector('.contact-page__contact-box-form');

if(formNewBtn) {
  formNewBtn.addEventListener('click', ()=> {
    formThankyouWrapper.classList.remove('show');
    formWrapper.classList.remove('hide');
  })
}


//wpcf7mailsent
//wpcf7submit

document.addEventListener('wpcf7mailsent', function (event) {
  if(event.detail.contactFormId == '5' || event.detail.contactFormId == '244') {
    formThankyouWrapper.classList.add('show');
    formWrapper.classList.add('hide');
  }
}, false);


/* Blog - category select */

const categoriesSelect = document.querySelector('#categories-select');

if(categoriesSelect) {
  categoriesSelect.addEventListener('change', (e)=>{
    const categoryURL = e.target.value;
    window.location = categoryURL;
  })
}